export const GET_PROMOCODE_REQUEST =
	"GET_PROMOCODE_REQUEST"
export const GET_PROMOCODE_SUCCESS =
	"GET_PROMOCODE_SUCCESS"
export const GET_PROMOCODE_FAIL =
	"GET_PROMOCODE_FAIL"
